import React from "react";
import './Link.css';


const Link2 = () => {
  return (
    <div className="links">
    <div className="container">
    <div className="column">
    <h3 className="perfect" style={{marginTop : "170px"}}>Bar Closing(Super Cold)</h3>
    <br />
    </div>


    <div className="cardstart" style={{marginTop : "30px"}}>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link51a.webp">
          <source src="link51a.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 1 : </b>Switch off super cold unit</h5>
      </div>
    </div>

     
<div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link41a.webp">
          <source src="link41a.mp4" type="video/mp4" />
        </video>     
         </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 2 : </b>Disengage and lift up dispenser, turning it anti-clockwise to remove it
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}> Hold and push down the entire lever before squeezing the bottom lever to disengage the dispenser</b>
       </h5>
      </div>
    </div>
 
    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link42a.webp">
          <source src="link42a.mp4" type="video/mp4" />
        </video>     
         </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 3 : </b>Connect the dispenser to the flushing adapter and turn it clockwise to secure it. Turn on the water supply
           </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link43a.webp">
          <source src="link43a.mp4" type="video/mp4" />
        </video>      
        </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 4 :  </b>Use a piece of tissue to clean leftover beer on the keg spearhead
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}> (IMPORTANT) This is for hygiene purposes to ensure the remaining beer in the keg does not get contaminated</b>
       </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link44a.webp">
          <source src="link44a.mp4" type="video/mp4" />
        </video>     
         </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b> Step 5 : </b>Use another piece of tissue to seal the keg spearhead
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}> (IMPORTANT) This is for hygiene purposes to ensure the remaining beer in the keg does not get contaminated</b> 
          </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link45a.webp">
          <source src="link45a.mp4" type="video/mp4" />
        </video>      
        </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 6 :  </b>Turn on the beer tap by pulling the beer handle towards you to flush out the remaining beer in the system.
             Stop when you see clear water flow</h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link46a.webp">
          <source src="link46a.mp4" type="video/mp4" />
        </video>     
         </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 7 :  </b>Turn off the CO2 flow by turning the cylinder knob clockwise
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}> (IMPORTANT) Ensure that the cylinder is properly tightened to prevent any CO2 gas leak</b>
           </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link47a.webp">
          <source src="link47a.mp4" type="video/mp4" />
        </video>     
         </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 8 :  </b>Prior to bar opening, 
        turn on CO2 flow by turning the cylinder knob anti-clockwise
        </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link48a.webp">
          <source src="link48a.mp4" type="video/mp4" />
        </video>     
         </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 9 :  </b>Remove the tissue paper from the keg spearhead</h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link49a.webp">
          <source src="link49a.mp4" type="video/mp4" />
        </video>     
         </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 10 : </b>Turn the dispenser anti-clockwise to remove it from the flushing adapter</h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link410a.webp">
          <source src="link410a.mp4" type="video/mp4" />
        </video>      
        </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 11 :  </b>Connect the dispenser with the keg spearhead, turning it clockwise to secure it, before squeezing the lever and pressing it down to engage the dispenser
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}> Ensure that the dispenser is aligned with the keg spearhead before turning, and squeeze the bottom lever before pushing the whole lever down</b></h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link411a.webp">
          <source src="link411a.mp4" type="video/mp4" />
        </video>     
         </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 12 :  </b>Pull the beer tap handle towards you to flush out the remaining water in the system and stop when you see clear beer flow</h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link413.webp">
          <source src="link413.mp4" type="video/mp4" />
        </video>      
        </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5  className="cardf-description"> <b>Step 13 :  </b>Turn on the super cold system 2 hours prior to start of bar operations <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}> This allows the super cold to have sufficient time to cool down</b></h5>
       
      </div>
    </div>
    </div>

    </div>
    </div>

    )
}

export default Link2;
